import React, { forwardRef } from 'react';
import { getBeginOfMonth, getDayOfWeek, getMonthIndex, getYear } from '../../utils/dates';
import language from '../../utils/language';
import { useLocalization } from '@appkit4/react-api';
var Weekdays = /*#__PURE__*/forwardRef(function (props, ref) {
  var activeStartDate = props.activeStartDate,
    formatShortWeekday = props.formatShortWeekday,
    locale = props.locale,
    firstDayOfWeek = props.firstDayOfWeek;
  var _useLocalization = useLocalization(),
    t = _useLocalization.t;
  var beginOfMonth = function beginOfMonth() {
    return getBeginOfMonth(activeStartDate);
  };
  var year = function year() {
    return getYear(beginOfMonth());
  };
  var monthIndex = function monthIndex() {
    return getMonthIndex(beginOfMonth());
  };
  var getHtml = function getHtml() {
    var _language$locale, _language$locale2, _language$locale3;
    var weekdays = [];
    var weekdaysNameMap = new Map();
    var weekdayMinNameMap = new Map();
    var keys = locale && ((_language$locale = language[locale]) === null || _language$locale === void 0 ? void 0 : _language$locale.keys) || language['en'].keys;
    var daysMinList = locale && ((_language$locale2 = language[locale]) === null || _language$locale2 === void 0 ? void 0 : _language$locale2.daysMin) || t('dayNamesMin');
    var daysList = locale && ((_language$locale3 = language[locale]) === null || _language$locale3 === void 0 ? void 0 : _language$locale3.daysFull) || t('dayNames');
    for (var i = 0; i < keys.length; i++) {
      weekdaysNameMap.set(keys[i], daysList[i]);
      weekdayMinNameMap.set(keys[i], daysMinList[i]);
    }
    for (var weekday = 0; weekday < 7; weekday += 1) {
      var weekdayDate = new Date(year(), monthIndex(), weekday - getDayOfWeek(beginOfMonth(), firstDayOfWeek));
      var weekdayName = formatShortWeekday && formatShortWeekday(locale, weekdayDate).replace('.', '');
      weekdays.push( /*#__PURE__*/React.createElement("span", {
        className: "ap-single-weekday",
        key: weekday,
        "aria-label": weekdaysNameMap.get(weekdayName),
        tabIndex: -1,
        "data-abbr": weekdaysNameMap.get(weekdayName)
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": true
      }, weekdayMinNameMap.get(weekdayName))));
    }
    return weekdays;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "ap-weekdays"
  }, getHtml());
});
export default Weekdays;